import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    codes: {
      choices: [],
      staff: [],
      complex: [],
      custom_form: [],
      signature: [],
      feed: [],
      gpa: [],
      reserved_place: [],
    },
  },
  mutations: {
    setSystemEventCodes: function (state, codes) {
      state.codes = codes;
    },
  },
  getters: {
    systemEventsCodesList: (state) => state.codes.choices.map((choice) => choice[0]),
    systemEventsMap: (state) => _.fromPairs(state.codes.choices),
  },
};
